import { Routes, Route, Navigate } from "react-router-dom";
// import PartnerDetails from "../pages/BankingPartnerPortal/PartnerDetails";
import BankingPartnerForm from "../components/AdminPortal/BankingPartnerDetails/AddCategory/BankingPartnerForm";
import MainLayout from "./MainLayout";
import BankingPartnerDashboard from "../pages/BankingPartnerPortal/BankingPartnerDashboard";
import CommunicationCenter from "../pages/BankingPartnerPortal/CommunicationCenter";
import Settings from "../pages/BankingPartnerPortal/Settings";
import Customer from "../pages/BankingPartnerPortal/Customer";
import LoanApplicationView from "../pages/BankingPartnerPortal/LoanApplicationView";

const BankingPartnerLayout = () => {
  return (
    <MainLayout>
      <Routes>
        <Route index element={<Navigate to="dashboard" />} />
        <Route path="add-partners" element={<BankingPartnerForm />} />
        <Route path="dashboard" element={<BankingPartnerDashboard />} />
        <Route path="customers" element={<Customer />} />
        <Route path="loan-applications/:id" element={<LoanApplicationView />} />
        <Route path="communication" element={<CommunicationCenter />} />
        <Route path="settings" element={<Settings />} />

        <Route
          path="*"
          element={
            <div className="flex items-center justify-center min-h-screen bg-[#131313] text-white p-4">
              <div className="text-center">
                <h1 className="text-5xl font-bold text-[#FFCA20] mb-4">404</h1>
                <h2 className="text-2xl mb-4">Page Not Found</h2>
                <p className="text-gray-400 mb-6">
                  The page you are looking for doesn't exist or you are not
                  authorised.
                </p>
                <a
                  href="/banking-partner/dashboard"
                  className="bg-[#FFCA20] hover:bg-yellow-600 text-black font-medium py-2 px-6 rounded"
                >
                  Go to Dashboard
                </a>
              </div>
            </div>
          }
        />
      </Routes>
    </MainLayout>
  );
};

export default BankingPartnerLayout;
